import { Box, Container, Typography } from '@mui/material';
import { useThemeMode } from '../context/ThemeContext';

export default function LegalMentions() {
  const { colors } = useThemeMode();

  return (
    <Box sx={{ bgcolor: colors.bgDefault, minHeight: '100vh', py: 8 }}>
      <Container maxWidth="md">
        <Typography variant="h3" sx={{ color: colors.textPrimary, fontWeight: 700, mb: 3 }}>
          Mentions legales
        </Typography>

        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 2, lineHeight: 1.8 }}>
          Les informations legales de l'editeur du site Publy Music, les conditions d'utilisation,
          et les coordonnees de contact seront publiees ici.
        </Typography>

        <Typography variant="body1" sx={{ color: colors.textSecondary, lineHeight: 1.8 }}>
          Cette page est accessible publiquement et peut etre enrichie avec les mentions obligatoires
          (raison sociale, hebergeur, contact, conditions, etc.).
        </Typography>
      </Container>
    </Box>
  );
}
